import { useState } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import { Container, Image, ErrorMessage, LoadingContainer } from "./styles";

const ProportionalImage = ({
  src,
  alt = "",
  width = "300px",
  height = "auto",
  objectFit = "cover",
  showLoadingState = true,
  showErrorState = true,
  ...rest
}) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleLoad = () => {
    setLoading(false);
    setError(false);
  };

  const handleError = () => {
    setLoading(false);
    setError(true);
  };

  return (
    <Container width={width} height={height} {...rest}>
      {loading && showLoadingState && (
        <LoadingContainer>
          {intl.formatMessage({ id: "proportional_image.loading" })}
        </LoadingContainer>
      )}

      {error && showErrorState ? (
        <ErrorMessage>
          {intl.formatMessage({ id: "proportional_image.not_available" })}
        </ErrorMessage>
      ) : (
        <Image
          src={src}
          alt={alt}
          objectFit={objectFit}
          onLoad={handleLoad}
          onError={handleError}
          style={{ display: loading ? "none" : "block" }}
        />
      )}
    </Container>
  );
};

ProportionalImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  objectFit: PropTypes.oneOf([
    "cover",
    "contain",
    "fill",
    "scale-down",
    "none",
  ]),
  showLoadingState: PropTypes.bool,
  showErrorState: PropTypes.bool,
};

export default ProportionalImage;
